module.exports = __webpack_public_path__ + "static/1-f465688bfa5b96cac716b94f41c30a78.jpg";